import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ProductCodeService from "services/Setup/Master/productCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productTypeList: {},
  productCodeList: {},
};

export const getProductCodeList = createAsyncThunk(
  "productCode/getProductCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProductCodeService.getProductCodeList(userInput);
      console.log("🚀 ~ response getProductCodeList:", response);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getProductType = createAsyncThunk(
  "productCode/getProductType",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProductCodeService.getProductType(userInput);
      console.log("🚀 ~ response getProductType:", response);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const productCode = createSlice({
  name: "productCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get product code list
      .addCase(getProductCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProductCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.productCodeList = action.payload;
      })
      .addCase(getProductCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get product code list
      .addCase(getProductType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProductType.fulfilled, (state, action) => {
        state.loading = false;
        state.productTypeList = action.payload;
      })
      .addCase(getProductType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  productCode.actions;

export default productCode.reducer;
